import { render } from "inferno";
import routes from "./routes/routes";
import { Provider } from "inferno-redux";
import configureStore from "./store/configureStore";
import "./registerServiceWorker";

const store = configureStore();

render(
  <Provider store={store}>{routes(store)}</Provider>,
  document.getElementById("app")
);



// WEBPACK FOOTER //
// ./src/index.js